import { Signal } from '@preact/signals'

interface FilterInputProps {
  value: Signal<string>
  placeholder?: string
  className?: string
}

export function FilterInput({
  value,
  placeholder = 'Filter...',
  className = 'w-full max-w-md',
}: FilterInputProps) {
  const handleInput = (e: Event) => {
    const target = e.target as HTMLInputElement
    value.value = target.value
  }

  return (
    <input
      type="text"
      placeholder={placeholder}
      value={value.value}
      onInput={handleInput}
      className={`${className} px-4 py-2 bg-slate-800 border border-slate-700 rounded-md text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
    />
  )
}
